<template>
    <div v-if="empty" />
    <div
        v-else
        class="fibre-b"
        :style="{ backgroundColor: color ?? fibres[position] }"
    >
        <div class="fibre-title">{{ String(position).padStart(2, '0') }}</div>
        <!--        <FontAwesomeIcon size="1x" icon="grip-lines" />-->
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { fibres } from '@connect-field/client/components/forms/PlanBoite/colors.data';

export default defineComponent({
    props: {
        color: {
            type: String,
            default: '#FFFFFF',
        },
        empty: {
            type: Boolean,
            default: false,
        },
        position: {
            type: Number,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return { fibres: fibres.orange };
    },
});
</script>

<style lang="scss" scoped>
.fibre-b {
    border-radius: 8px 0 0 8px;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    align-content: center;
}

.fibre-title {
    background: white;
    border: 2px solid black;
    border-radius: 20px;
    padding: 2px 5px;
    color: black;
    margin: 4px;
}
</style>
